import { useCallback, useEffect, useRef, useState } from "react";
import ContractorSearchSection from "../../../Components/ContractorsPage/Components/ContractorSearchSection";
import useLoadingContractors from "../../../Components/ContractorsPage/useLoadingContractors";
import { useAuth } from "../../../Providers/AuthProvider";
import Contractor from "./Contractor";
import { useCart } from "../../../Providers/CartProvider";
import { toast } from "react-toastify";
import { useCustomer } from "../../../Providers/CustomerProvider";
import { useShop } from "../../../Providers/ShopProvider";
import { useOrder } from "../../../Providers/OrderProvider";
import LoadingSpinner from "../../../Components/Components/LoadingSpinner";
import { useParams } from "../../../Providers/ParamsProvider";

const Contractors = ({ setCustIdToGeneratePriceList, setShowMessageBoxQuestionPopup, setContractorHasPriceList, setNewSelectedContractor, setShowMessageCalculatePriceList }) => {
    const [filterCriteria, setFilterCriteria] = useState({ textSearch: '', salesTeam: '', city: '', zipCode: '' })
    const [pageNumber, setPageNumber] = useState(0)
    const { changeSelectedCustomer, authState, handleSelectCustomer } = useAuth()
    const { cartItems } = useCart()
    const observer = useRef()
    const { handleAddTaskForSendPriceList } = useCustomer()
    const { setProductsFilter } = useShop()
    const { clearOrderInfo } = useOrder()
    const { contractors, hasMore, loading, handleGetCustomerDiscounts } = useLoadingContractors(filterCriteria, pageNumber)
    const { isMobile } = useParams()
    const [customerDiscounts, setCustomerDiscounts] = useState([])

    useEffect(() => {
        setPageNumber(0)
    }, [filterCriteria])

    useEffect(() => {
        getInitialData()
    }, [])

    const getInitialData = async () => {
        const discounts = await handleGetCustomerDiscounts()
        setCustomerDiscounts(discounts)
    }

    const lastBookElementRef = useCallback(node => {
        if (loading) return
        if (observer.current) observer.current.disconnect()
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setPageNumber(prevPageNumber => prevPageNumber + 1)
            }
        })
        if (node) observer.current.observe(node)
    }, [loading, hasMore])

    const handleCustomerChecked = (contractor) => {
        handleSelectCustomer(contractor)
        setContractorHasPriceList(contractor.priceListGenerateDate === "0001-01-01T00:00:00" ? false : true)
        if (cartItems && cartItems.basketItems && cartItems.basketItems.length > 0) {
            setNewSelectedContractor(contractor)
            setShowMessageBoxQuestionPopup(true)
        }
        else {
            changeSelectedCustomer(contractor.custId, contractor.siteId, contractor.whId, contractor.name, contractor.fullName, '', contractor.nip, contractor.zipCode, contractor.city, contractor.street,
                contractor.houseNum, contractor.locumNum, contractor.email, contractor.phone, contractor.dpl)
            setProductsFilter(prev => ({
                ...prev,
                SiteId: contractor.siteId ? contractor.siteId : '',
                WhId: contractor.whId ? contractor.whId : '',
            }))
            clearOrderInfo()
            if (handleAddTaskForSendPriceList(contractor.custId)) {
                const message = contractor.priceListGenerateDate === "0001-01-01T00:00:00" ? ' Kontrahent nie posiada wygenerowanego wcześniej cennika, generowanie nowego cennika może potrwać kilka minut.' : ''
                toast.success(`Wysłano zadanie tworzenia cennika dla wybranego kontrahenta. ${message}`)
            }
        }
    }

    return (
        <div>
            <div className="row justify-content-center">
                <div className="justify-content-center">
                    {/* Sekcja filtrów */}
                    <div className='ms-3 me-3 mb-3'>
                        <ContractorSearchSection
                            filterCriteria={filterCriteria}
                            setFilterCriteria={setFilterCriteria}
                        />
                    </div>
                    <div className="table-responsive">
                        <table className={`${isMobile ? 'table-font-small' : ''} table table-bordered`}>
                            <thead>
                                <tr>
                                    <th style={{ width: '5%' }}></th>
                                    <th style={{ width: "24%" }}>Nazwa kontrahenta</th>
                                    <th style={{ width: "9%" }}>NIP</th>
                                    <th style={{ width: "7%" }}>Konto klienta</th>
                                    <th style={{ width: '7%' }}>Numer klienta</th>
                                    <th style={{ width: '8%' }}>Zes. handlowy</th>
                                    <th style={{ width: "24%" }}>Adres</th>
                                    <th style={{ width: '10%' }}>GR.Rabat.</th>
                                    <th style={{ width: "3%" }}></th>
                                    <th style={{ width: "3%" }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {contractors.map((c, index) => {
                                    if (contractors.length === index + 1) {
                                        return <Contractor
                                            contractor={c}
                                            isSelected={authState.custId === c.custId ? true : false}
                                            handleCustomerChecked={handleCustomerChecked}
                                            lastBookElementRef={lastBookElementRef}
                                            setShowMessageCalculatePriceList={setShowMessageCalculatePriceList}
                                            setCustIdToGeneratePriceList={setCustIdToGeneratePriceList}
                                            setContractorHasPriceList={setContractorHasPriceList}
                                            customerDiscounts={customerDiscounts}
                                        />
                                    } else {
                                        return <Contractor
                                            contractor={c}
                                            isSelected={authState.custId === c.custId ? true : false}
                                            handleCustomerChecked={handleCustomerChecked}
                                            setShowMessageCalculatePriceList={setShowMessageCalculatePriceList}
                                            setCustIdToGeneratePriceList={setCustIdToGeneratePriceList}
                                            setContractorHasPriceList={setContractorHasPriceList}
                                            customerDiscounts={customerDiscounts}
                                        />
                                    }
                                })}
                            </tbody>
                        </table>
                        {loading && <LoadingSpinner />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contractors;
